import React from 'react';
import Badge from 'assets/icons/badge.svg';

export default function GoldBadge() {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
            <Badge height={150} width={150} />
        </div>
    );
}
